module.exports = __webpack_public_path__ + "static/media/canalbolditalic.90a82819.ttf";